import React from "react";

/**
 * LCH brand system — engraved crest monogram + serif wordmark.
 * Uses `currentColor` for the mark so the parent controls color / theming.
 */

export function LchMark({ className = "", title = "Le Collectif Horloger" }) {
  return (
    <svg
      viewBox="0 0 48 56"
      className={className}
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 2 L44 8.5 V27 C44 40 34.5 49 24 54 C13.5 49 4 40 4 27 V8.5 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M24 6.4 L39.6 11.4 V27 C39.6 37.4 31.8 44.9 24 49.2 C16.2 44.9 8.4 37.4 8.4 27 V11.4 Z" stroke="currentColor" strokeWidth="0.7" strokeOpacity="0.5" strokeLinejoin="round" />
      <path d="M24 12.5 C24 15 22.6 16.4 22.6 16.4 L24 15.6 L25.4 16.4 C25.4 16.4 24 15 24 12.5 Z" fill="currentColor" />
      <text x="24" y="36.5" textAnchor="middle" fontFamily="'Crimson Text', Georgia, 'Times New Roman', serif" fontSize="17" fontWeight="600" letterSpacing="0.5" fill="currentColor">LCH</text>
      <line x1="16.5" y1="41.5" x2="31.5" y2="41.5" stroke="currentColor" strokeWidth="0.8" strokeOpacity="0.6" />
    </svg>
  );
}

const SIZES = {
  sm: { mark: "h-9 w-auto", word: "text-[13px]", tag: "text-[8px]", gap: "gap-2.5" },
  md: { mark: "h-12 w-auto", word: "text-[17px]", tag: "text-[9px]", gap: "gap-3" },
  lg: { mark: "h-16 w-auto", word: "text-[22px]", tag: "text-[10px]", gap: "gap-3.5" },
};

/**
 * Horizontal lockup: crest mark + stacked serif wordmark.
 */
export default function BrandLogo({
  size = "md",
  className = "",
  markColor = "text-[#c9a86a]",
  wordColor = "text-[var(--text)]",
  showTagline = true,
}) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-center ${s.gap} ${className}`}>
      <LchMark className={`${s.mark} ${markColor}`} />
      <span className="flex flex-col leading-[1.05]">
        <span className={`font-serif ${wordColor} tracking-[0.2em] ${s.word} font-semibold`}>LE COLLECTIF</span>
        <span className={`font-serif ${wordColor} tracking-[0.2em] ${s.word} font-semibold`}>HORLOGER</span>
        {showTagline && (
          <span className={`${s.tag} text-[#c9a86a] tracking-[0.34em] mt-[3px] opacity-80`}>AN ATELIER DUGAS HOUSE</span>
        )}
      </span>
    </span>
  );
}
